import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IOrdenCompra} from '../modelos/IOrdenCompra';

@Injectable({
  providedIn: 'root'
})
export class OrdenCompraService {

  private diccionarioModulo: any;
  private url: string;
  private urlCompras: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlCompras = this._util.getPortalCompras();  
  }

  obtenerTodo(): Observable<IOrdenCompra[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesCompra.obtenerTodo
    );
  }

  obtenerPorId(id: number): Observable<IOrdenCompra> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesCompra.obtenerPorId + id
    );
  }

  obtenerCantidadBase(solped: number): Observable<IOrdenCompra> {
    return this._commom.peticionGetConHeader(
      this.urlCompras + this.diccionarioModulo.url.ordenesCompra.obtenerCantidadBase + solped
    );
  }

}
